/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type TodoListItemFragment = { __typename: 'TodoItemNode', id: string, title: string, isDone: boolean, time?: any | null, assignee?: { __typename: 'TodoItemUser', id: string, fullname?: string | null } | null, team?: { __typename: 'Team', id: string, name: string, isActive: boolean } | null };

export const TodoListItemFragmentDoc = gql`
    fragment TodoListItem on TodoItemNode {
  id
  title
  isDone
  time
  assignee {
    id
    fullname
  }
  team {
    id
    name
    isActive
  }
}
    `;